import { Component, effect, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Toast } from '@openng/ngx-toastr';
import { TenantAnalyzerService } from 'src/app/services/tenant-analyzer/tenant-analyzer.service';
import { ITenantAnalyzerRequest } from '../tenant-analyzer-modal/tenant-analyzer-modal.component';
import { AnalyzerType, OriginType } from 'src/app/models/tenant-analzer/tenant-analzer.model';
import { CommonModule } from '@angular/common';
import { helpLinks } from 'src/app/data/help-links';

@Component({
    selector: 'bt-ngx-custom-toaster',
    templateUrl: './ngx-custom-toaster.component.html',
    styleUrls: ['./ngx-custom-toaster.component.scss'],
    preserveWhitespaces: false,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, RouterModule]
})
export class NgxCustomToasterComponent extends Toast implements OnInit {

	public display = {
		title: '',
		message: '',
		customToasterAlert: false,
		warning: false,
		success: false,
		error: false,
		info: false,
		customToasterNotification: false,
		customLinkActivity: false,
		customActionViewDetails: false,
		customActionViewSummary: false,
		customActionViewRequests: false,
		customActionViewReports: false,
		customActionRetryTenantScan: false,
		customActionOpenDashboardPulse: false,
		customActionOpenDashboardIntranet: false,
		customActionContactSupport: false,
		customActionOpenPricing: false,
		customActionOpenOrphanedWorkspaces: false
	};

	constructor() {
		super();
		effect(() => {
			const classes = this.options().toastClass;
			const toastClasses = this.toastClasses();
			this.display = {
				title: this.title(),
				message: this.message(),
				customToasterAlert: classes.includes('custom-toaster-alert'),
				warning: toastClasses.includes('warning'),
				success: toastClasses.includes('success'),
				error: toastClasses.includes('error'),
				info: toastClasses.includes('info'),
				customToasterNotification: classes.includes('custom-toaster-notification'),
				customLinkActivity: classes.includes('custom-link-activity'),
				customActionViewDetails: classes.includes('custom-action-view-details'),
				customActionViewSummary: classes.includes('custom-action-view-summary'),
				customActionViewRequests: classes.includes('custom-action-view-requests'),
				customActionViewReports: classes.includes('custom-action-view-reports'),
				customActionRetryTenantScan: classes.includes('custom-action-retry-tenant-scan'),
				customActionOpenDashboardPulse: classes.includes('custom-action-open-dashboard-pulse'),
				customActionOpenDashboardIntranet: classes.includes('custom-action-open-dashboard-intranet'),
				customActionContactSupport: classes.includes('custom-action-contact-support'),
				customActionOpenPricing: classes.includes('custom-action-open-pricing'),
				customActionOpenOrphanedWorkspaces: classes.includes('custom-action-open-orphaned-workspaces')
			};
		});
	}

	undoString = 'undo';

	public activityPath = "";

	private router = inject(Router);
	private tenantAnalyzerService = inject(TenantAnalyzerService);

	action(event: Event) {
		event.stopPropagation();
		this.undoString = 'undid';
		this.toastPackage.triggerAction();
		return false;
	}
	ngOnInit(): void {
		const url = this.router.url;
		const catalogIdRegex = /catalog\/([^/]+)/; // Regex to match "catalog/id"
		const match = url.match(catalogIdRegex); // Match the regex against the URL
		this.activityPath = (match ? match[0] : "") + "/activity/actions/all";
	}

	processLinks(e: Event) {
		const element = e.target;
		if (!(element instanceof HTMLElement)) return;
		if (element.nodeName === 'A') {
			e.preventDefault();
			const link = element.getAttribute('href');
			if (link) {
				if (link.startsWith('mailto:')) {
					window.location.href = link;
				} else {
					this.router.navigate([link]);
				}
			}
		}
	}

	goToTenantSettings() {
		this.router.navigate(["settings", "workspace", "tenant"])
	}

	public viewDetails() {
		const customValue = this.options().toastClass.split(" ").filter((x: string) => x.includes("custom-value-"))?.at(0)?.replace("custom-value-", "")
		if (customValue) {
			this.router.navigate(["activity", "actions", customValue, "general"])
		} else {
			this.router.navigate(["activity", "actions", "all"])
		}
	}

	public viewSummary() {
		const customValue = this.options().toastClass.split(" ").filter((x: string) => x.includes("custom-value-"))?.at(0)?.replace("custom-value-", "")
		if (customValue) {
			this.router.navigate(["activity", "actions", customValue, "summary"])
		} else {
			this.router.navigate(["activity", "actions", "all"])
		}
	}

	public viewRequests() {
		const customValue = this.options().toastClass.split(" ").filter((x: string) => x.includes("custom-value-"))?.at(0)?.replace("custom-value-", "")
		if (customValue) {
			this.router.navigate(["activity", "requests", customValue])
		} else {
			this.router.navigate(["activity", "requests", "all"])
		}
	}

	public viewReports() {
		this.router.navigate(["activity", "generated-reports", "all"])
	}

	public retryTenantScan() {
		const origin = this.options().toastClass.split(" ").filter((x: string) => x.includes("custom-value-"))?.at(0)?.replace("custom-value-", "");
		const originType = origin ? OriginType[origin as keyof typeof OriginType] : undefined;

		const request: ITenantAnalyzerRequest = new ITenantAnalyzerRequest(AnalyzerType.Full, originType);
		this.tenantAnalyzerService.startTenantAnalyzer(request);
	}

	public openDashBoard(navigateTo: string) {

		if (navigateTo === "pulse") {
			this.router.navigate(['pulse']);
		} else if (navigateTo === "intranet") {
			this.router.navigate(['intranet', 'dashboard']);
		}
	}

	public contactSupport() {
		// INTERCOM_TODO
	}
	
	public openPricing() {
		window.open(helpLinks.deploymentPricing, "_blank");
	}

	public openOrphanedWorkspacesReport() {
		this.router.navigate(["pulse/dashboard/workspaces/membership/orphaned"])
	}
}
